import type { ProjectGraphResponse } from '@avisoma/shared';
import { entityViewTitle } from '../../components/ID';
import { nodeLabel } from './nodeLabel';

/** The page title: the working engine when the graph names one, else the project's short id. */
export function graphTitle(graph: ProjectGraphResponse | undefined, id: string | undefined): string {
  const entry = graph?.entryNodeId ? graph.nodes.find((n) => n.id === graph.entryNodeId) : undefined;
  return entry?.kind === 'engine' ? `${nodeLabel(entry)} · Project graph` : entityViewTitle(id, 'Project Graph');
}
